import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { errorSideEffects, loadingSideEffects, RTKSideEffectSchema, successSideEffects } from "..";
import { Toastify } from "../../../components/Toaster";

export interface SigningKeyToken {
  Kid: string;
  VerifyKey: string;
  ExpireAt?: string;
  status?: "in-use" | "next" | "previous";
  Fingerprint?: string;
  Thumbprint?: string;
}

export interface SigningKeysState extends RTKSideEffectSchema {
  keys: SigningKeyToken[];
  revokedKeys: SigningKeyToken[];
  isRotating: boolean;
  isRotateAndRevoke: boolean;
}

const initialState: SigningKeysState = {
  isLoading: false,
  isSuccess: false,
  isError: false,
  error: "",
  keys: [],
  revokedKeys: [],
  isRotating: false,
  isRotateAndRevoke: false
};

const signingKeysSlice = createSlice({
  name: "signingKeys",
  initialState,
  reducers: {
    // Fetch signing keys
    getSigningKeysRequest(state) {
      Object.assign(state, loadingSideEffects);
    },
    getSigningKeysSuccess(state, action: PayloadAction<{ keys: SigningKeyToken[]; revokedKeys: SigningKeyToken[] }>) {
      Object.assign(state, successSideEffects);
      state.keys = action.payload.keys;
      state.revokedKeys = action.payload.revokedKeys;
    },
    getSigningKeysError(state, action: PayloadAction<string>) {
      Object.assign(state, errorSideEffects);
      state.error = action.payload;
      Toastify("error", action.payload);
    },

    // Rotate key
    rotateSigningKeyRequest(state) {
      state.isRotating = true;
    },
    rotateSigningKeySuccess(state) {
      state.isRotating = false;
      Toastify("success", "Signing key rotated successfully.");
    },
    rotateSigningKeyError(state, action: PayloadAction<string>) {
      state.isRotating = false;
      Toastify("error", action.payload);
    },

    // Rotate N Revoke key
    rotateNRevokeSigningKeyRequest(state) {
      state.isRotateAndRevoke = true;
    },
    rotateNRevokeSigningKeySuccess(state) {
      state.isRotateAndRevoke = false;
      Toastify("success", "Signing keys rotated and revoked successfully.");
    },
    rotateNRevokeSigningKeyError(state, action: PayloadAction<string>) {
      state.isRotateAndRevoke = false;
      Toastify("error", action.payload);
    }
  }
});

export const {
  getSigningKeysRequest,
  getSigningKeysSuccess,
  getSigningKeysError,
  rotateSigningKeyRequest,
  rotateSigningKeySuccess,
  rotateSigningKeyError,
  rotateNRevokeSigningKeyRequest,
  rotateNRevokeSigningKeySuccess,
  rotateNRevokeSigningKeyError
} = signingKeysSlice.actions;

export default signingKeysSlice.reducer;
